import {put,takeLatest,call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    GET_OPTION,
    GET_OPTION_SUCCESS,
    GET_OPTION_ERROR
}
    from "../../../actions/menu/options";

function* getOptionSaga(action) {
    try {
        const data=yield call(optionService.GetOption,action.payload)
        yield put({
            type: GET_OPTION_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_OPTION_ERROR,error: error.data
        });
    }
}


export function* getOptionSagaWatcher() {
    yield takeLatest(GET_OPTION,getOptionSaga);
}